var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.pageLoading
      ? _c(
          "div",
          { staticClass: "h-screen w-screen grid place-items-center" },
          [
            _c(
              "div",
              {
                staticClass:
                  "flex items-center font-logo font-bold text-4xl text-light-purple animate-pulse"
              },
              [_vm._v("\n      Blüm Report\n    ")]
            )
          ]
        )
      : !_vm.report
      ? _c(
          "div",
          { staticClass: "h-screen w-screen grid place-items-center bg-white" },
          [
            _c(
              "div",
              {
                staticClass:
                  "w-full lg:w-148 py-5 px-4 lg:px-10 flex flex-col items-center gap-2 bg-pure-white border-l-8 border-red-cherry rounded-xl shadow-lg"
              },
              [
                _c("BlTextTitle4", {
                  attrs: { text: "404: Report Not Found" }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex flex-col" },
                  [
                    _c("BlTextBody2", {
                      staticClass: "text-center",
                      attrs: {
                        text:
                          "Oops! It looks like the report you're trying to access doesn't exist or the URL is incorrect. Please contact your therapist for assistance."
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]
        )
      : _c(
          "div",
          [
            _c("ReportHeader", { attrs: { mode: "preview" } }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "flex",
                style: { minHeight: "calc(100vh - 3.75rem)" }
              },
              [
                _c("ParentReportHelper", {
                  attrs: { sectionFocusedId: _vm.sectionFocusedId },
                  on: {
                    "change-focus-id": function($event) {
                      _vm.sectionFocusedId = $event
                    }
                  }
                }),
                _vm._v(" "),
                _c("Editor", { attrs: { mode: "preview" } }),
                _vm._v(" "),
                _c("div", { staticClass: "w-20 flex-shrink-0" })
              ],
              1
            )
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-713c15fe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-713c15fe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/ParentReport.vue
// module id = null
// module chunks = 